
module Meevo.Components.Search {

    export class MeevoSearch implements ng.IDirective {
        restrict = "E";
        templateUrl = "app/components/search/searchTemplate.html";
        replace = true;
        controller = "meevo.components.search.SearchController";
        controllerAs = "vm";
        scope = {};
   
        constructor(private $rootScope: ng.IRootScopeService,            
            protected identityService: Meevo.Components.Common.IIdentityService) {
        }
        link = (scope: any, element: JQuery, attr: angular.IAttributes, ctrl: ISearchController) => {

            scope.isSingleLocation = (): boolean => {
                if (Model.Guard.isSomething(this.identityService.current().isSingleLocation))
                    return this.identityService.current().isSingleLocation;
                else
                    return false;
            }
        }
        static factory(): angular.IDirectiveFactory {
            let directive = ($rootScope, identityService) => {
                return new MeevoSearch($rootScope,identityService);
            };

            directive.$inject = ["$rootScope", 
                'meevo.components.common.IdentityService'
            ];

            return directive;
        }
}

  angular.module("meevo.components.search")
    .directive("meevoSearch", MeevoSearch.factory());
}